<template>
  <div>
    <header v-if="label">
      <div>
        <doe-fieldset-heading>{{ label }}</doe-fieldset-heading>
        <paragraph v-if="description" class="mt-2" :description="description"></paragraph>
      </div>
      <div v-if="editable">
        <router-link
          :to="{
            name: routeName,
            params: { statementUuid: $route.params.statementUuid },
            query: { edit: true }
          }"
        >
          Edit
        </router-link>
      </div>
    </header>
    <div
      class="border-solid border-0 border-t border-b border-gray-600 max-w-4xl pt-5 pb-1"
    >
      <span v-for="(field, index) in filteredSchema" :key="index">
        <component
          :is="field.fieldType"
          :value="value[field.name]"
          v-bind="field"
          :class="{
            'border-t border-gray-500 pt-4': hasTopBorder(
              index,
              field.fieldType
            )
          }"
        />
      </span>
    </div>
  </div>
</template>

<script>
import DoeFieldsetHeading from "@/components/typography/FieldsetHeading.vue";
import Paragraph from "@/components/typography/Paragraph";
import DoeIcon from "@/components/icon/Icon.vue";
import FieldText from "@/components/grid/CellText.vue";
import FieldTextarea from "@/components/grid/CellTextarea.vue";
import Date from "@/components/grid/CellDate.vue";
import Check from "@/components/grid/CellCheck.vue";
import Number from "@/components/grid/CellNumber.vue";
import Radio from "@/components/grid/CellRadio.vue";
import Upload from "@/components/grid/CellUpload.vue";
import FieldsetHeading from "@/components/grid/CellHeading.vue";
import School from "@/components/grid/CellSchool.vue";
import Dropdown from "@/components/grid/CellDropdown.vue";
import MultiSelect from "@/components/grid/CellMultiSelect.vue";

export default {
  name: "DoeGrid",
  props: {
    value: {
      type: Object
    },
    name: {
      type: String,
      required: true
    },
    description: {
      type: [String, Array],
      required: false
    },
    label: {
      type: String,
      required: true
    },
    editable: {
      type: Boolean
    },
    routeName: {
      type: String
    },
    schema: {
      type: Array,
      required: true
    }
  },
  components: {
    DoeFieldsetHeading,
    Paragraph,
    DoeIcon,
    FieldsetHeading,
    FieldText,
    FieldTextarea,
    Date,
    Check,
    Number,
    Radio,
    Upload,
    School,
    Dropdown,
    MultiSelect
  },
  data() {
    return {
      hiddenComponents: [
        "PageHeading",
        "FieldHeading",
        "FormDivider",
        "FormActions",
        "FieldDateHeading",
        "Paragraph",
        "Radio",
      ]
    };
  },
  filters: {
    capitalise(value) {
      if (!value) return "";
      value = value.toString();
      return value.charAt(0).toUpperCase() + value.slice(1);
    }
  },
  computed: {
    filteredHiddenComponents() {
      return !this.value.parentEmail
        ? this.hiddenComponents
        : [...this.hiddenComponents, "Check", "Upload"];
    },
    filteredSchema() {
      return this.schema.filter(
        field => !this.filteredHiddenComponents.includes(field.fieldType)
      );
    }
  },
  methods: {
    hasTopBorder(index, type) {
      return type === "FieldsetHeading" && index !== 0;
    }
    // hasFieldValue(key) {
    //   if (Array.isArray(key)) {
    //     key = key.join("|");
    //   }
    //   let pattern = new RegExp(Object.keys(this.value).join("|"), "gi");
    //   return key.search(pattern) >= 0;
    // },
    // getFieldValue(key) {
    //   if (Array.isArray(key)) {
    //     return this.getFieldValueFromArray(key);
    //   } else {
    //     return this.getFieldValueFromString(key);
    //   }
    // },
    // getFieldValueFromString(key) {
    //   let pattern = new RegExp(Object.keys(this.value).join("|"), "gi");
    //   let value = key.replace(pattern, matched => {
    //     return this.value[matched];
    //   });
    //   return value;
    // },
    // getFieldValueFromArray(key) {
    //   let value = key
    //     .map(item => {
    //       let value = this.getFieldValueFromString(item);
    //       if (item !== value) {
    //         return value;
    //       }
    //     })
    //     .filter(item => {
    //       return item != null;
    //     });
    //   return value.join(", ");
    // }
  }
};
</script>

<style lang="scss" scoped>
header {
  @apply flex flex-row flex-wrap items-center justify-between max-w-4xl pb-2;
}
a {
  @apply font-light font-sans leading-none subpixel-antialiased text-base text-blue-900 underline;
}
</style>
